import Cookies from 'js-cookie';
import { pushGaData } from '../common';
import { cookieSegmentToHeaderSegment, setIsFromSelfServiceCookie, toHeaderSegment } from '../utils';
const SEGMENTS = ['private', 'business', 'selfservice'];
const LABELS = {
    private: 'header.main.private',
    business: 'header.main.business',
    selfservice: 'header.main.self-service',
    frontline: 'header.main.frontline',
    shop: 'header.main.shop'
};
const GA_VALUE = {
    private: 'Eraklient',
    business: 'Äriklient',
    selfservice: 'Iseteenindus',
    frontline: 'Teenindusveeb',
    teliaee: 'telia.ee'
};
const headerSegment = (rootStore) => {
    const { app, URLData } = rootStore.environmentStore;
    const { translate, translations } = rootStore.translationsStore;
    const { setLocation, segment } = rootStore.locationStore;
    const { setSection } = rootStore.sectionStore;
    const { isPublicWebWithSelfServiceMenu, customSegment } = rootStore.menuItemStore;
    const { authData, setLoginCallback, isDealer } = rootStore.ssoStore;
    const { onHeaderSegmentChange } = rootStore.externalCallbackStore;
    const { forceSegment } = rootStore.propStateStore;
    const headerSegmentName = customSegment ? cookieSegmentToHeaderSegment(customSegment) : toHeaderSegment(segment, app !== 'public');
    const pushSegmentGa = (value) => {
        const eventLabel = GA_VALUE[value];
        pushGaData({
            eventAction: 'Choose Segment',
            eventLabel
        });
    };
    const addFrontlineSegmentItemForDealer = (segmentItems) => {
        if (isDealer) {
            segmentItems.items.push({
                label: translate(LABELS.frontline),
                mobileLabel: translate(`${LABELS.frontline}.mobile`),
                url: URLData.getSelfServiceURL('/teenindus'),
                employee: true,
                onClick: (event) => setLocationAndPushGa(event, 'frontline'),
                current: app === 'frontline'
            });
        }
    };
    const setLocationAndPushGa = (event, value) => {
        pushSegmentGa(value);
        if (['private', 'business'].includes(value)) {
            Cookies.set('segment', value === 'business' ? 'b2b' : 'b2c', { domain: '.telia.ee', expires: 365 });
        }
        setIsFromSelfServiceCookie(false);
        if (value === 'selfservice' && !authData.isLoggedIn) {
            setSection('sso');
            event.preventDefault();
            const targetHref = `${event.currentTarget.href}`;
            setLoginCallback(() => {
                window.location.assign(targetHref);
            });
        }
        else {
            if (!onHeaderSegmentChange) {
                setLocation(event);
            }
            else {
                onHeaderSegmentChange(event, value);
            }
            setSection(null);
        }
    };
    const isSelfServiceApp = () => {
        return ['selfservice', 'itb', 'web3'].includes(app);
    };
    const selfServiceSegment = (current) => {
        return {
            label: translate(LABELS.selfservice),
            mobileLabel: translate(`${LABELS.selfservice}.mobile`),
            url: URLData.getSegmentLink('selfservice'),
            onClick: (event) => setLocationAndPushGa(event, 'selfservice'),
            current: current
        };
    };
    if (!translations) {
        return undefined;
    }
    if (forceSegment !== 'public' && (forceSegment === 'selfservice' || isSelfServiceApp() || isPublicWebWithSelfServiceMenu())) {
        const publicSegment = authData.customerType === 'B2B' ? 'business' : 'private';
        const segmentItems = {
            items: [
                {
                    label: translate('header.main.public'),
                    url: URLData.getSegmentLink(publicSegment),
                    mobileLabel: translate('header.main.public.mobile'),
                    icon: { modifiers: '#arrow-left' },
                    onClick: (event) => setLocationAndPushGa(event, 'teliaee')
                },
                selfServiceSegment(true)
            ]
        };
        addFrontlineSegmentItemForDealer(segmentItems);
        return segmentItems;
    }
    const segmentItems = {
        items: SEGMENTS.map((name) => ({
            label: translate(LABELS[name]),
            mobileLabel: translate(`${LABELS[name]}.mobile`),
            url: URLData.getSegmentLink(name),
            onClick: (event) => setLocationAndPushGa(event, name),
            current: app !== 'frontline' && name === headerSegmentName
        }))
    };
    addFrontlineSegmentItemForDealer(segmentItems);
    return segmentItems;
};
export default headerSegment;
//# sourceMappingURL=HeaderSegment.js.map